var fresnelSchlickPS = `
// Schlick's approximation
vec3 getFresnel(float cosTheta, vec3 f0) {
		float fresnel = pow(1.0 - max(cosTheta, 0.0), 5.0);
		float glossSq = dGlossiness * dGlossiness;
		vec3 ret = f0 + (max(vec3(glossSq), f0) - f0) * fresnel;
		#ifdef LIT_IRIDESCENCE
				return mix(ret, dIridescenceFresnel, vec3(dIridescence));
		#else
				return ret;
		#endif    
}

float getFresnelCC(float cosTheta) {
		float fresnel = pow(1.0 - max(cosTheta, 0.0), 5.0);
		return 0.04 + (1.0 - 0.04) * fresnel;
}
`;

export { fresnelSchlickPS as default };
